import React from 'react'
import { useTranslation } from "react-i18next"
import Stack from '@mui/material/Stack'
import { Container } from '@mui/system'
import { Box, Typography } from '@mui/material'
import { useGlosario } from "../hooks/useGlosario"
import { user, useUser } from "../hooks/useUser"
import { Titulo } from "../components/commons/Titulo"
import Parser from 'html-react-parser';
import "../styles/Glosario.css"
import { AutocompleteSearch } from '../components/commons/AutocompleteSearch'
import ButtonScrollToTop from '../components/commons/ButtonScrollToTop'
import { useTools } from '../hooks/useTools'

export function Glosario() {

    const { t } = useTranslation()
    const { listaTerminos } = useGlosario()
    const scroll = (value) => {
        if (value) scrollToElement("#" + quitarCaracteresExtrañosId(value.termino))
    }
    const { scrollToElement, quitarCaracteresExtrañosId } = useTools()

    return (
        <Container>

            <ButtonScrollToTop />
            <Titulo titulo={t("Glosario.titulo")} size={"2.5em"} />

            {listaTerminos && (
                <Stack>
                    <AutocompleteSearch dataList={listaTerminos} optionLabel={lt => lt.termino} labelText={t("Glosario.buscarTermimo")} onChangeHanddle={scroll} disabled={false} />
                    {(listaTerminos.map((glosario, index) =>
                        <Box id={quitarCaracteresExtrañosId(glosario.termino)} key={index}>
                            <Typography
                                variant="h5"
                                color="primary"
                                sx={{
                                    marginTop: "1em",
                                    textAlign: "justify",
                                }}
                            >
                                {glosario.termino}
                            </Typography>
                            <Box maxWidth={{xs: "90vw", md: "auto"}} style={{wordWrap: "break-word"}}>
                                <Typography
                                    variant="body1"
                                    component="div"
                                    sx={{
                                        marginTop: "1em",
                                        textAlign: "justify"
                                    }}
                                >
                                    {Parser(glosario.definicion)}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>
            )}
        </Container>
    )
}
